import slick from 'slick-carousel';
$('#storeImgSliderContainer').slick({
  dots: true,
  arrows: false,
  infinite: true,
  fade: true,
  speed: 1000,
  autoplay: true,
  autoplaySpeed: 5000
});